module.exports = __webpack_public_path__ + "img/tiklanish-2.d6f9079c.png";